import { Language } from '@shared/modules/smart-commands/common/translations/interfaces/language';
import { EnumObjectValue } from '@shared/utils/common/types';

export const AdditionalTranslateFromLanguage = {
  detect: 'detect'
} as const;

export interface GetLanguagesResponse {
  languages: Language[];
}

export interface TranslateResponse {
  from_language: string | EnumObjectValue<typeof AdditionalTranslateFromLanguage>;
  to_language: string;
  translated_text: string;
}
